module.exports = __webpack_public_path__ + "static/media/1-4.46aa702b.mp3";